import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';

import { AuthAccentButton, AuthCard, AuthCardConnecting, AuthCardIntro } from '@/components/auth/auth-card';

export function LoginPage() {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
    const location = useLocation();
    const navigate = useNavigate();

    // The root is the only safe default: `TenantRedirect` sits there and picks
    // between the current organization's dashboard and organization creation.
    // (`/tenants` is not a route — landing there renders the router's error
    // boundary.)
    const from = (location.state as { from?: Location })?.from?.pathname || '/';

    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate, from]);

    const handleLogin = () => {
        loginWithRedirect({ appState: { returnTo: from } });
    };

    if (isLoading) {
        return <AuthCardConnecting />;
    }

    return (
        <AuthCard
            note="Authentication is handled securely by Auth0 Universal Login."
            footerLeft={
                <span>
                    New to ESCloud?{' '}
                    <Link
                        to="/pricing"
                        className="font-medium text-[color:var(--auth-accent)] hover:underline"
                    >
                        See plans
                    </Link>
                </span>
            }
        >
            <AuthCardIntro title="Welcome back." description="Sign in to access your planning workspace" />
            <AuthAccentButton onClick={handleLogin}>Sign in</AuthAccentButton>
        </AuthCard>
    );
}
